export default __webpack_public_path__ + "static/media/xbox-4.a026f74e.png";